<div class="container">
  <ng-template #modal>
    <div class="seal-unseal-modal modal" [ngClass]="{ 'modal--open': isModalOpen$ | async }">
      <div class="modal__content">
        @if (!isCallingApi && sealingTimeRange && ((isModalOpen$ | async) ?? false)) {
          <div class="modal__body">
            <h3>{{ getTermForMode() | titlecase }} Content</h3>
            <p>{{ getTermForMode() | titlecase }} the following time period:</p>
            <div class="seal-unseal-modal-timerange">
              <strong
                ><ftr-time-range-text [timeRange]="sealingTimeRange" [showSeconds]="true"></ftr-time-range-text
              ></strong>
            </div>
            @if (serverError) {
              <ftr-notification [type]="notificationType.Error">{{ serverError }}</ftr-notification>
            }
          </div>
          <footer class="modal__footer" cdkTrapFocus cdkTrapFocusAutoCapture="true">
            <button
              ftrButton
              [color]="buttonColor.Grey"
              [displayType]="buttonDisplayType.Text"
              (click)="closeSealingModal()"
              class="seal-unseal-modal__cancel-button"
            >
              Cancel
            </button>
            <button
              ftrButton
              [displayType]="buttonDisplayType.Text"
              (click)="confirm()"
              class="seal-unseal-modal__confirm-button"
            >
              {{ getTermForMode() | titlecase }}
            </button>
          </footer>
        } @else {
          <div class="seal-unseal-modal__processing modal__body">
            <p>{{ (mode === modes.Seal ? terms.sealing.singular : terms.unsealing.singular) | titlecase }}</p>
            <ftr-loader [isLoading]="true" [iconOnly]="true" [inline]="true"></ftr-loader>
          </div>
        }

        <ng-template #processing>
          <div class="seal-unseal-modal__processing modal__body">
            <p>{{ (mode === modes.Seal ? terms.sealing.singular : terms.unsealing.singular) | titlecase }}</p>
            <ftr-loader [isLoading]="true" [iconOnly]="true" [inline]="true"></ftr-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>
